import { DocumentType, gql } from '@/__generated__/gql'

export const ContentListYITagsLisByTagGrouptQuery = gql(`
query ContentList_YITagsListByGroupQuery(
    $path: String!,
    $offset: Int = 0,
    $limit: Int = 25,
    $language: [String!] = ["en"]
    $contentReferencesTo: [ContentContentReferencesToFilterInput] = []
) {
    contentList(offset: $offset, limit: $limit, where: { contentType: { eq: "tag" }, path:{eq: $path},  language:{in: $language}}, contentReferencesTo: $contentReferencesTo) {
        content {
            id
            contentReferencesTo {
                id
                contentFrom (language: $language) {
                    id
                    language
                    title
                    contentId
                    contentType
                    published
                    contentProvider{
                        ...Content_ProviderCommonFragment
                        providerKey
                    }
                }
            }
        }
    }
}`)

export type RawData = DocumentType<typeof ContentListYITagsLisByTagGrouptQuery>
